import React from "react";
import { Form, Switch, CurrencyBox } from "fw/forms";
import { Col, FormGroup, Row } from "react-bootstrap";
import { Label, Button } from "fw/components";
import { ContentBody, VeteranAppIdHeader } from "areas/shared/components";
import { DocumentUpload } from "areas/shared/controls";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import * as FormManager from 'fw/forms/form/FormManager';
import { TooltipCode } from 'areas/shared/consts';

class EquipmentInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            loading: true,
            title: "",
            form: this.props.stepData,
            tooltips: this.props.stepInfo.tooltips
        };
    };

    updatePostData = (form, dirty) => {
        this.checkBlankFields(form);
        this.setState({ form });
        this.props.onStepChange(form);

        if (dirty === true)
            FormManager.dirt(this._form);
    }

    checkBlankFields = (form) => {
        //check Location Equipment fields
        if (!form.locationEquipment) {
            form.tangibleEquipmentAmount = null;
            form.personalLocation = false;
            form.businessLocation = false;
            form.warehouseLocation = false;
            form.garageLocation = false;
            form.mobileStorageLocation = false;
        }
    }

    componentDidMount() {
        // Add an Asset Purchase Agreement (APA) document control to be filled
        if (this.state.form.apaDocuments.length === 0)
            this.addApaDocument();
        // Add an Equipment Lease Agreement (ELA) document control to be filled
        if (this.state.form.elaDocuments.length === 0)
            this.addElaDocument();
    }

    handleUploadApaDocumentChange = (file, index) => {
        let form = this.state.form;

        form.apaDocuments[index].storageToken = file.storageToken;
        form.apaDocuments[index].fileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleRemoveApaDocument = (e, i) => {
        e.preventDefault();
        let form = this.state.form;
        form.apaDocuments.splice(i, 1);

        this.updatePostData(form, true);
    }

    addApaDocument = () => {
        this.state.form.apaDocuments.push({
            equipmentDocumentId: -Math.abs(Date.now() | 0)
        });
        this.props.onStepChange(this.state.form);
    };

    renderApaDocuments = () => {
        return this.state.form.apaDocuments.map((item, index) => (
            <Row key={item.equipmentDocumentId}>
                <Col md={11}>
                    <DocumentUpload
                        storageToken={item.storageToken}
                        fileName={item.fileName}
                        onChange={file => this.handleUploadApaDocumentChange(file, index)}
                        wrapFileNameLength={40}
                    />
                </Col>
                {index > 0 ?
                    <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -15, paddingLeft: 0 }}>
						<Button type="button" bsStyle="link" onClick={(e) => this.handleRemoveApaDocument(e, index)} title="Remove Financial Document">
                            <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
						</Button>
                    </Col>
                    : null}
            </Row>
        ));
    };

    handleUploadElaDocumentChange = (file, index) => {
        let form = this.state.form;
        form.elaDocuments[index].storageToken = file.storageToken;
        form.elaDocuments[index].fileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleRemoveElaDocument = (i) => {
        let form = this.state.form;
        form.elaDocuments.splice(i, 1);

        this.updatePostData(form, true);
    }

    addElaDocument = () => {
        this.state.form.elaDocuments.push({
            equipmentDocumentId: -Math.abs(Date.now() | 0)
        });
        this.props.onStepChange(this.state.form);
    };

    renderElaDocuments = () => {
        return this.state.form.elaDocuments.map((item, index) => (
            <Row key={item.equipmentDocumentId}>
                <Col md={11}>
                    <DocumentUpload
                        storageToken={item.storageToken}
                        fileName={item.fileName}
                        onChange={file => this.handleUploadElaDocumentChange(file, index)}
                        wrapFileNameLength={40}
                    />
                </Col>
                {index > 0 ?
                    <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -15, paddingLeft: 0 }}>
						<Button type="button" bsStyle="link" onClick={() => this.handleRemoveElaDocument(index)} title="Remove Financial Document">
                            <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
						</Button>
                    </Col>
                    : null}
            </Row>
        ));
    };

    handleFacilityUploadChange = (file) => {
        let form = this.state.form;
        form.facilityStorageToken = file.storageToken;
        form.facilityFileName = file.fileName;

        this.updatePostData(form, true);
    };

    setTip = (property) => {
        const tooltip = this.state.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.tip : null
    }
    
    render() {
        return (
            <ContentBody>
                <Form
                    onChange={this.updatePostData}
                    values={this.state.form}
                    unsavedChangesWarning={true}
                    disabled={this.props.stepInfo.readonly || this.props.stepInfo.isRenewal}
                    ref={(form) => { this._form = form }}>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={12}>
                                    <h3 style={{ position: 'relative' }}>Asset Purchase Agreement and Receipts – <small>Please submit all required Asset Purchase Agreement(s) and Receipt(s)</small> <VeteranAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.stepInfo.daysOpen} /></h3>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={5}>
                                    {this.state.form.apaDocuments != null &&
                                        this.state.form.apaDocuments.length > 0 && (
                                            <FormGroup>
                                                <Label htmlFor="apaUpload" tip={this.setTip(TooltipCode.EQUIPMENT.ACTIVEASSETAGR)} required>Active Asset Agreement or Contracts over $3,000</Label>
                                                {this.renderApaDocuments()}
                                                {(this.state.form.apaDocuments == null || this.state.form.apaDocuments.length < 5) &&
													<Button type="button" bsStyle="link" onClick={this.addApaDocument}>
                                                        Add another Asset Purchase Agreement
													</Button>
												}
                                            </FormGroup>
                                        )}
                                    <br></br>
                                    {this.state.form.elaDocuments != null &&
                                        this.state.form.elaDocuments.length > 0 && (
                                            <FormGroup>
                                                <Label htmlFor="elaUpload" tip={this.setTip(TooltipCode.EQUIPMENT.EQUIPMENTLEASEAGR)} required>Equipment Lease Agreement</Label>
                                                {this.renderElaDocuments()}
                                                {(this.state.form.elaDocuments == null || this.state.form.elaDocuments.length < 5) &&
													<Button type="button" bsStyle="link" onClick={this.addElaDocument}>
                                                        Add another Equipment Lease Agreement
													</Button>
												}
                                            </FormGroup>
                                        )}
                                </Col>
                                <Col md={1} />
                                <Col md={6}>
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Row>
                                                    <Col md={12}>
                                                        <Label htmlFor="locationEquipment" tip={this.setTip(TooltipCode.EQUIPMENT.EQUIPMENTLOC)}>Does your Company carry or hold any equipment or inventory at a location?</Label>
                                                        <Switch name="locationEquipment" labelLeft="No" labelRight="Yes" bsStyle="success" />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12}>
                                                        {this.state.form !== null && this.state.form.locationEquipment ?
                                                            (
                                                                <React.Fragment>
                                                                    <Row>
                                                                        <Col md={7}>
                                                                            <Label htmlFor="tangibleEquipmentAmount" tip={this.setTip(TooltipCode.EQUIPMENT.DOLLARAMOUNTEQINV)} required>Dollar Amount of Equipment or Inventory</Label>
                                                                        </Col>
                                                                        <Col md={5}>
                                                                            <CurrencyBox
                                                                                name="tangibleEquipmentAmount"
                                                                                placeholder="Please provide whole numbers"
                                                                                positiveNumbersOnly
                                                                                precision={0}
                                                                                maxLength={10} />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={7}>
                                                                            <h4>Located At</h4>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={7}>
                                                                            <Label htmlFor="personalLocation" tip={this.setTip(TooltipCode.EQUIPMENT.PERSONALHOMERES)}>Personal Home/Residence?</Label>
                                                                        </Col>
                                                                        <Col md={5}>
                                                                            <Switch name="personalLocation" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={7}>
                                                                            <Label htmlFor="businessLocation" tip={this.setTip(TooltipCode.EQUIPMENT.COMPANYLOC)}>Company location?</Label>
                                                                        </Col>
                                                                        <Col md={5}>
                                                                            <Switch name="businessLocation" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={7}>
                                                                            <Label htmlFor="warehouseLocation" tip={this.setTip(TooltipCode.EQUIPMENT.WAREHOUSELOC)}>Other Warehouse or Storage Facility?</Label>
                                                                        </Col>
                                                                        <Col md={5}>
                                                                            <Switch name="warehouseLocation" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={7}>
                                                                            <Label htmlFor="garageLocation" tip={this.setTip(TooltipCode.EQUIPMENT.GARAGELOC)}>Other Garage or Maintenance Facility?</Label>
                                                                        </Col>
                                                                        <Col md={5}>
                                                                            <Switch name="garageLocation" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={7}>
                                                                            <Label htmlFor="mobileStorageLocation" tip={this.setTip(TooltipCode.EQUIPMENT.MOBILESTORAGELOC)}>Mobile Storage Unit (Container, POD, Truck, etc.)?</Label>
                                                                        </Col>
                                                                        <Col md={5}>
                                                                            <Switch name="mobileStorageLocation" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                                                        </Col>
                                                                    </Row>
                                                                </React.Fragment>)
                                                            : null}
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </ContentBody>
        )
    }
}

export default EquipmentInfo;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/equipmentInfo/EquipmentInfo.js